export default __webpack_public_path__ + "static/decoration-1-fd4246385f1b20335cc9bd214f0b79f7.svg";